import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Backdrop from '@mui/material/Backdrop';
import { AppState } from './store/rootReducer';
// import makeStyles  from '@mui/styles/makeStyles';
import {createStyles} from "@mui/material";
import { Theme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { IErrorMessage } from './Interfaces/UI/IErrorMessage';
import { clearServerMessage } from './store/application/actions';
import { ApplicationDispatch } from './store/application/types';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { LoadingPanel } from '@amsanalytics/react-shared-library';
import { styled } from '@mui/material/styles';
// const useStyles: any = makeStyles((theme: Theme) =>
//   createStyles({
//     backdrop: {
//       zIndex: theme.zIndex.drawer + 1,
//     },
//   }),
// );

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1000000,
}));

export interface GlobalServicesProps {
  children: React.ReactNode;
}

export const GlobalServices: React.FC<GlobalServicesProps> = props => {
  // const classes = useStyles();
  const dispatch = useDispatch<ApplicationDispatch>();
  const loading: boolean = useSelector((state: AppState) => state.applications.loading);
  const serverMessage: IErrorMessage = useSelector((state: AppState) => state.applications.serverMessage);
  const [showMessage, setShowMessage] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      dispatch(clearServerMessage());
    };
  }, []);

  useEffect(() => {
    // if there is a message from the server, we'll display it to the user
    if (serverMessage && serverMessage.message) {
      serverMessage.isError ? console.error(serverMessage.message) : console.info(serverMessage.message);
      setShowMessage(true);
    }
  }, [serverMessage]);

  const handleSnackbarClose = (event: React.SyntheticEvent<any> | Event, reason: SnackbarCloseReason) => {
    dispatch(clearServerMessage());
    if (reason === 'clickaway') {
      return;
    }

    setShowMessage(false);
  };

  const handleAlertClose = (event: React.SyntheticEvent<any>) => {
    dispatch(clearServerMessage());
    setShowMessage(false);
  };

  return (
  <>
    <CssBaseline />
    {props.children}
    <StyledBackdrop open={loading}>
      <LoadingPanel label='Loading...' />
    </StyledBackdrop>
    <Snackbar
      open={showMessage}
      autoHideDuration={6000}
      onClose={handleSnackbarClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert onClose={handleAlertClose} severity={serverMessage.isError ? "error" : "info"}>
        {serverMessage.message}
      </Alert>
    </Snackbar>
  </>
  );
}
